import * as React from 'react';

function SvgSpringPlus10(props) {
  return (
    <svg
      width={46}
      height={315}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.142 22.545v.528L2.625 25.928l20.105 3.278-20.105 3.278 20.103 3.276-20.103 3.278 20.103 3.278-20.103 3.277L22.73 48.87 2.625 52.148l20.103 3.277-20.103 3.278 20.103 3.277-2.586.422v2.962h5v-.529l17.516-2.855-20.105-3.277 20.105-3.278-20.104-3.277 20.104-3.278-20.104-3.277 20.104-3.277-20.105-3.278 20.105-3.277-20.104-3.277 20.104-3.278-20.102-3.278 2.586-.421v-2.962h-5z"
        fill={props.springcolor}
      />
      <path
        d="M22.642 112.261v7.235l-10.052 6.792 20.104 13.583-20.104 13.584 20.104 13.584-20.104 13.584 20.104 13.584L12.59 207.79l20.104 13.584-20.104 13.584 20.104 13.584-20.104 13.584 20.104 13.583-10.052 6.792v7.235"
        stroke={props.springcolor}
        strokeWidth={5}
        strokeLinecap="square"
      />
      <path
        d="M34.175 0h-23v23h23V0zM34.175 292h-23v23h23v-23z"
        fill="#5BAD92"
      />
    </svg>
  );
}

export default SvgSpringPlus10;
